"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { useAuthenticatedContent } from "../../../hooks/useAuthenticatedContent";
import useDeviceInfo from "../../../hooks/useDeviceInfo";
import ConnectWallet from "../../common/ConnectWallet";
import UserSetUpProfileCta from "../../user/utils/set-up-profile/UserSetUpProfileCta";
import WavesDesktop from "../WavesDesktop";
import WavesMobile from "../WavesMobile";
function getConnectPrompt(contentState: ReturnType<typeof useAuthenticatedContent>["contentState"]): ReactNode {
  switch (contentState) {
    case "needs-profile":
      return <>
          <h1 className="tw-text-xl tw-font-bold">
            You need to set up a profile to continue.
          </h1>
          <UserSetUpProfileCta />
        </>;
    case "not-available":
      return <h1 className="tw-text-xl tw-font-bold">
          This content is not available.
        </h1>;
    case "loading":
    case "measuring":
    case "not-authenticated":
    case "ready":
    default:
      return null;
  }
}
function getNotAuthenticatedContent({
  children,
  containerClassName,
  isApp
}: {
  readonly children: ReactNode;
  readonly containerClassName: string;
  readonly isApp: boolean;
}): ReactNode {
  if (isApp) {
    return <ConnectWallet />;
  }
  return <div className="tw-flex-1" id="waves-content">
      <WavesDesktop showLeftSidebar={true}>
        <div className={containerClassName}>{children}</div>
      </WavesDesktop>
    </div>;
}

// Main layout content that uses the Layout context
function WavesLayoutContent(t0) {
  const $ = _c(14);
  const {
    children
  } = t0;
  const {
    contentState
  } = useAuthenticatedContent();
  const {
    isApp
  } = useDeviceInfo();
  let t1;
  if ($[0] !== contentState) {
    t1 = getConnectPrompt(contentState);
    $[0] = contentState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const connectPrompt = t1;
  let content;
  if (contentState === "ready") {
    const Component = isApp ? WavesMobile : WavesDesktop;
    let t2;
    if ($[2] !== children) {
      t2 = <div className="tw-relative tw-flex tw-flex-col tw-flex-1 tailwind-scope">{children}</div>;
      $[2] = children;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== Component || $[5] !== t2) {
      t3 = <div className="tw-flex-1" id="waves-content"><Component>{t2}</Component></div>;
      $[4] = Component;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    content = t3;
  } else {
    if (contentState === "not-authenticated") {
      let t2;
      if ($[7] !== children || $[8] !== isApp) {
        t2 = getNotAuthenticatedContent({
          children,
          containerClassName: "tw-relative tw-flex tw-flex-col tw-flex-1 tailwind-scope",
          isApp
        });
        $[7] = children;
        $[8] = isApp;
        $[9] = t2;
      } else {
        t2 = $[9];
      }
      content = t2;
    } else {
      let t2;
      if ($[10] !== connectPrompt) {
        t2 = connectPrompt === null ? null : <div className="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-px-6"><div className="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-text-center">{connectPrompt}</div></div>;
        $[10] = connectPrompt;
        $[11] = t2;
      } else {
        t2 = $[11];
      }
      content = t2;
    }
  }
  let t2;
  if ($[12] !== content) {
    t2 = <div className="tailwind-scope tw-flex tw-flex-col tw-overflow-hidden tw-bg-black">{content}</div>;
    $[12] = content;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}
export default function WavesLayout(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <WavesLayoutContent>{children}</WavesLayoutContent>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}